import { Box, Button, Typography } from '@material-ui/core'
import { houseAmpLogo, successFinancing } from 'assets/index'
import styles from './styles.module.scss'
import React from 'react'
import { history } from 'helpers/index'
import { ArrowBack } from '@material-ui/icons'


type Props = {}

const SuccessFinancing = (props: Props) => {
    const replace = history.useReplace()
    return (
        <Box className={styles.container}>
            <img src={successFinancing} alt="happy family" className={styles.successImg} />
            <img src={houseAmpLogo} alt='house amp logo' className={styles.houseAmpLogo} />
            <Typography className={styles.text}>
                We’re awaiting confirmation from <a href='https://secure.houseamp.com/#/homeowner-signup?from=cfd1f2ee-27e7-440e-93e7-97de24d4675c' target='_blank' rel='noopener noreferrer'>HouseAmp</a> and will notify you as soon as we have an update.
            </Typography>
            <Button
                className={styles.greyButton}
                style={{ padding: '0 16px' }}
                startIcon={<ArrowBack style={{ width: '16px', height: '16px' }} />}
                onClick={() => replace('/p/estimates')}
            >
                <Typography className={styles.primaryLatoText}>
                    Go Back to Estimates
                </Typography>
            </Button>
        </Box>
    )
}

export default SuccessFinancing